import { frontendURL } from '../../../helper/URLHelper';
import CondoMngt from './Index.vue';
import CondoDetails from './component/CondoDetails.vue';
import store from '../../../store/index';
import { subscriptionGuard } from '../../../helper/subscriptionHelper';

const MODULE_ID = 'condo_management';

// Only accounts whose active module is condo_management may open these routes.
// The module is loaded lazily (App.vue), so fetch it here if a direct URL load
// gets here first. If it can't be determined, fall back to the dashboard.
const ensureCondoModule = async (to, next) => {
  let moduleId = store.getters['stripe/getModuleId'];
  if (!moduleId) {
    try {
      await store.dispatch('stripe/fetchModule');
    } catch (e) {
      // handled below: unknown module is treated as not active
    }
    moduleId = store.getters['stripe/getModuleId'];
  }
  if (moduleId !== MODULE_ID) {
    return next({ name: 'dashboard' });
  }
  return next();
};

const condoAccessGuard = (to, from, next) =>
  subscriptionGuard(
    to,
    from,
    arg => {
      if (arg !== undefined) return next(arg);
      return ensureCondoModule(to, next);
    },
    store
  );

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/condo_management'),
      name: 'condo_management',
      component: CondoMngt,
      meta: {
        permissions: ['administrator'],
      },
      beforeEnter: condoAccessGuard,
    },
    {
      path: frontendURL('accounts/:accountId/condo_details/:condoId'),
      name: 'condo_details',
      component: CondoDetails,
      meta: {
        permissions: ['administrator'],
      },
      beforeEnter: condoAccessGuard,
    },
  ],
};
